var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239.38,
    height: 54.2,
    viewBox: "0 0 239.38 54.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.2,
    height: 54.2,
    rx: 6.24,
    fill: "#355ffe"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.73,
    width: 54.2,
    height: 54.2,
    rx: 6.24,
    fill: "#355ffe"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123.46,
    width: 54.2,
    height: 54.2,
    rx: 6.24,
    fill: "#355ffe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 185.18,
    width: 54.2,
    height: 54.2,
    rx: 6.24,
    fill: "#355ffe"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.43,26a1.58,1.58,0,0,0,.94,2.67,10.42,10.42,0,0,1,9.18,9.17,1.53,1.53,0,0,0,.43.94,1.57,1.57,0,0,0,2.67-.94,10.39,10.39,0,0,1,9.18-9.17,1.56,1.56,0,0,0,0-3.1,10.42,10.42,0,0,1-9.17-9.18,1.54,1.54,0,0,0-.44-.94,1.57,1.57,0,0,0-2.66.94,10.42,10.42,0,0,1-9.18,9.18A1.5,1.5,0,0,0,15.43,26Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.16,26a1.57,1.57,0,0,0,.94,2.67,10.4,10.4,0,0,1,9.17,9.17,1.54,1.54,0,0,0,.44.94,1.57,1.57,0,0,0,2.67-.94,10.4,10.4,0,0,1,9.17-9.17,1.62,1.62,0,0,0,.94-.43,1.57,1.57,0,0,0-.94-2.67,10.44,10.44,0,0,1-9.18-9.18,1.48,1.48,0,0,0-.43-.94,1.57,1.57,0,0,0-2.66.94,10.42,10.42,0,0,1-9.18,9.18A1.48,1.48,0,0,0,77.16,26Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.88,26a1.58,1.58,0,0,0,.94,2.67A10.39,10.39,0,0,1,149,37.82a1.54,1.54,0,0,0,.44.94,1.56,1.56,0,0,0,2.66-.94,10.42,10.42,0,0,1,9.18-9.17,1.62,1.62,0,0,0,.94-.43,1.57,1.57,0,0,0-.94-2.67,10.44,10.44,0,0,1-9.18-9.18,1.53,1.53,0,0,0-.43-.94,1.57,1.57,0,0,0-2.66.94,10.43,10.43,0,0,1-9.18,9.18A1.53,1.53,0,0,0,138.88,26Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.61,26a1.58,1.58,0,0,0,.94,2.67,10.42,10.42,0,0,1,9.18,9.17,1.59,1.59,0,0,0,.43.94,1.57,1.57,0,0,0,2.67-.94A10.39,10.39,0,0,1,223,28.65a1.56,1.56,0,0,0,0-3.1,10.42,10.42,0,0,1-9.18-9.18,1.56,1.56,0,0,0-3.1,0,10.42,10.42,0,0,1-9.17,9.18A1.53,1.53,0,0,0,200.61,26Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourStar);
export default __webpack_public_path__ + "static/media/four_star.69e9454a5e6e5bc41d9df0bfe332b896.svg";
export { ForwardRef as ReactComponent };